import { Services } from '@sigma-frontend-libs/commons'

import { moderationColors, moderationStatusIcons } from '@/utils'

import squircle from '@/components/icon/squircle'
import comments from '@/components/services/sendernames/item/comments'
import moderationButtons from '@/components/services/sendernames/item/moderation/buttons'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderType(h) {
  if (this.viewport.size.width > 430) {
    return h(
      squircle,
      {
        props: {
          iconSVG: this.iconSVG,
          color: this.iconSVG,
          tooltip: this.getTranslate(`${Services.sendings}.types.${this.value.type}`)
        }
      }
    )
  }
}
function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value,
        label: this.getTranslate(`${Services.sendernames}.labels.name`),
        icon: moderationStatusIcons[this.value.moderation],
        color: moderationColors[this.value.moderation],
        iconTooltip: this.getTranslate(`${Services.sendernames}.statuses.${this.value.moderation}`),
        service: Services.sendernames,
        pathToTitle: 'name',
        readonly: this.isAttached && this.canGetSendernamesAsUser,
        copy: true
      }
    }
  )
}
function renderOwner(h) {
  if (this.viewport.size.width > 640) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          copy: true
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.sendernames}-item__info`]: true,
        [`${Services.sendernames}-item__info--admin`]: this.canGetUsersAsResellerUp
      }
    },
    [
      renderType.call(this, h),
      renderTitle.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderComments(h) {
  if (this.viewport.size.width > 1280) {
    return h(
      comments,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}

function renderModerationButtons(h) {
  return h(
    moderationButtons,
    {
      props: {
        value: this.value
      }
    }
  )
}

function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services.sendernames
      }
    }
  )
}

function renderCreatedAt(h) {
  if (this.viewport.size.width > 768) {
    return h(
      date,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `service-template-item ${Services.sendernames}-item hover-parent hover-parent--opacity`
    },
    [
      renderInfo.call(this, h),
      renderComments.call(this, h),
      renderModerationButtons.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
